import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatSelectModule, MatTableModule, MatTabsModule, MatAutocompleteModule, MatInputModule, MatTooltipModule } from '@angular/material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChartModule } from 'primeng/chart';
import { ProjectMetricsComponent } from './project-metrics.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DashboardScreenshotsComponent } from './dashboard-screenshots.component';
import { ProjectDashboardModule } from '../project/project.module';
import { ProjectCreateModule } from '../../projects/project-create/project-create.module';
import { TimesheetViewModule } from '../../timesheet-view/timesheet-view.module';
import { SharedModule } from 'app/shared/shared.module';

const routes = [
    { path: '', redirectTo: 'project-metrics', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'project-metrics', component: ProjectMetricsComponent, canActivate: [AuthGuardService] }
];

@NgModule({
    declarations: [
        ProjectMetricsComponent,
        DashboardScreenshotsComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        MatTabsModule,
        NgxChartsModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseWidgetModule,
        TableModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatInputModule,
        ChartsModule,
        MatTooltipModule,
        ChartModule,
        ProjectDashboardModule,
        ProjectCreateModule,
        TimesheetViewModule,
        SharedModule
    ],

})
export class ProjectMetricsModule { }

